import React from "react";
import { useNavigate } from "react-router-dom";
import PublicHeader from "../components/homepage/public/PublicHeader";
import PublicFooter from "../components/homepage/public/PublicFooter";

const styles = {
  page: {
    fontFamily: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    background: "#fff",
    color: "#0f172a",
  },
  container: { maxWidth: "1100px", margin: "0 auto", padding: "0 20px" },
  hero: {
    padding: "54px 0",
    background: "radial-gradient(circle at top, #f2f4fa 0, #ffffff 62%)",
    borderBottom: "1px solid #e2e8f0",
  },
  heroTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "42px",
    lineHeight: 1.06,
    margin: 0,
    color: "#020617",
  },
  heroText: { marginTop: "14px", fontSize: "15px", color: "#475569", lineHeight: 1.9 },
  heroActions: { marginTop: "18px", display: "flex", gap: "10px", flexWrap: "wrap" },
  btn: {
    fontSize: "13px",
    padding: "10px 18px",
    borderRadius: "999px",
    border: "1px solid #d0d7e2",
    background: "#ffffff",
    cursor: "pointer",
    fontWeight: 700,
  },
  btnPrimary: {
    background: "linear-gradient(135deg, #1d4ed8, #0b1530)",
    color: "#fff",
    borderColor: "transparent",
    boxShadow: "0 10px 25px rgba(15,23,42,0.14)",
  },
  section: { padding: "70px 0" },
  sectionAlt: {
    padding: "70px 0",
    background: "#f8fafc",
    borderTop: "1px solid #e2e8f0",
    borderBottom: "1px solid #e2e8f0",
  },
  h2: { fontFamily: "'Playfair Display', serif", fontSize: "28px", margin: "0 0 10px", color: "#020617" },
  p: { fontSize: "14px", color: "#64748b", lineHeight: 1.9, margin: 0 },
  steps: { marginTop: "22px", display: "grid", gap: "16px" },
  step: {
    display: "flex",
    gap: "16px",
    alignItems: "flex-start",
    padding: "16px",
    borderRadius: "18px",
    border: "1px solid #e2e8f0",
    background: "#fff",
  },
  stepNum: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #1d4ed8, #0b1530)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800,
    fontSize: "14px",
    flexShrink: 0,
  },
  stepTitle: { fontWeight: 800, margin: 0, fontSize: "16px", color: "#0f172a" },
  stepText: { marginTop: "6px", fontSize: "13px", color: "#64748b", lineHeight: 1.7 },
};

export default function AdmissionsPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <PublicHeader />

      <section style={styles.hero}>
        <div style={styles.container}>
          <h1 style={styles.heroTitle}>Admissions</h1>
          <p style={styles.heroText}>
            Join True Education with a simple process: schedule a free consultation, meet our team,
            and build a plan that fits your goals. We welcome students and families in Cumming and
            the greater Atlanta area.
          </p>
          <div style={styles.heroActions}>
            <button
              style={{ ...styles.btn, ...styles.btnPrimary }}
              onClick={() => navigate("/tutoring/sat")}
            >
              Explore SAT Tutoring
            </button>
            <button style={styles.btn} onClick={() => navigate("/login")}>
              Login
            </button>
          </div>
        </div>
      </section>

      <section style={styles.section}>
        <div style={styles.container}>
          <h2 style={styles.h2}>How to Get Started</h2>
          <p style={styles.p}>
            We keep admissions straightforward so you can focus on learning.
          </p>
          <div style={styles.steps}>
            <div style={styles.step}>
              <span style={styles.stepNum}>1</span>
              <div>
                <h3 style={styles.stepTitle}>Diagnostic & plan</h3>
                <p style={styles.stepText}>
                  For test prep, we use diagnostics to identify gaps and build a focused, personalized plan.
                </p>
              </div>
            </div>
            <div style={styles.step}>
              <span style={styles.stepNum}>2</span>
              <div>
                <h3 style={styles.stepTitle}>Free consultation</h3>
                <p style={styles.stepText}>
                  Book a call or visit. We review your results, discuss goals and timeline, and answer your questions.
                </p>
              </div>
            </div>
            <div style={styles.step}>
              <span style={styles.stepNum}>3</span>
              <div>
                <h3 style={styles.stepTitle}>Enroll and begin</h3>
                <p style={styles.stepText}>
                  Once we agree on the program and schedule, you’re set to start.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={styles.sectionAlt}>
        <div style={styles.container}>
          <h2 style={styles.h2}>Contact Us</h2>
          <p style={styles.p}>
            Ready to take the next step? Call or email to schedule your free consultation.
          </p>
          <p style={styles.p}>
            <strong>Phone:</strong> (470) 470-4715<br />
            <strong>Email:</strong> cumming@trueeducation.com<br />
            <strong>Address:</strong> 580 Peachtree Pkwy #102, Cumming, GA 30041
          </p>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
